/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type RenderCatalogEmailInput = {
    readonly message?: string | null;
    readonly pageTypeId: string;
    readonly recipientEmails: ReadonlyArray<string | null>;
    readonly rootId: string;
    readonly senderEmail: string;
    readonly senderName: string;
    readonly clientMutationId?: string | null;
};
export type RenderCatalogEmailMutationVariables = {
    readonly input: RenderCatalogEmailInput;
};
export type RenderCatalogEmailMutationResponse = {
    readonly renderCatalogEmail: {
        readonly clientMutationId: string | null;
    } | null;
};
export type RenderCatalogEmailMutation = {
    readonly response: RenderCatalogEmailMutationResponse;
    readonly variables: RenderCatalogEmailMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "RenderCatalogEmailInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "renderCatalogEmail",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "RenderCatalogEmailPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "clientMutationId",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "RenderCatalogEmailMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "RenderCatalogEmailMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "RenderCatalogEmailMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/RenderCatalogEmailMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '79ebeba0fdb4ccd5ea495b5341d04f9c';
export default node;
